export default __webpack_public_path__ + "static/media/MADSmania.9c572a85162a925076a49a5c7be2b8f1.webp";